import { apiUrl } from '@configs/environment';
import httpClient from '@shared/api/httpClient';

export const fetchAllLocationsData = (): Promise<string[]> =>
  httpClient.get(`${apiUrl}/locations/countries/`).then((resp) => resp.data.data);
